export var BANK_INFO = {
    bankInfoForm: {},
    setBankInfoForm: function () { },
};
export var JOB_FORM = {
    title: null,
    subtitle: null,
    actions: [],
};
export var JOB_RUNNER = {
    loading: true,
    linkApiResponse: null,
    makeRequest: function () { },
    isDefaultStep: true,
};
export var JOB_STEP_HISTORY = {
    addJobStepHistory: null,
    jobStepHistory: [],
    isRevertingLastJobStep: false,
    revertLastJobStep: null,
};
export var LINK_API_ROUTER = {
    currentFlow: null,
    currentJob: null,
    goToNextFlow: null,
    goToPrevFlow: null,
    goToDefaultSearchState: null,
    initializeRouter: null,
};
